import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Wallet, Plus, Trash2, LogIn, Briefcase } from "lucide-react";
import { api } from "../lib/api";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export const LeaveBalanceSection = ({ employeeId, canEdit }) => {
  const [b, setB] = useState(null);
  const [f, setF] = useState({ date: "", kind: "return", note: "" });
  const [op, setOp] = useState("");
  useEffect(() => { api.empLeaveBalance(employeeId).then((r) => { setB(r); setOp(String(r.opening_balance)); }).catch(() => {}); }, [employeeId]);
  const run = async (fn, msg) => { try { const r = await fn(); setB(r); toast.success(msg); } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } };
  if (!b) return null;
  return (
    <div className="mt-4 space-y-3 rounded-2xl border border-emerald-200 bg-emerald-50/30 p-3" data-testid="leave-balance-section">
      <div className="flex flex-wrap items-end gap-x-6 gap-y-1">
        <p className="flex items-center gap-1.5 font-heading font-bold text-emerald-800"><Wallet className="h-4 w-4" /> رصيد الإجازات
          <span className="font-mono-nums text-2xl" data-testid="leave-balance-value">{b.balance}</span> يوم</p>
        <span className="text-xs text-slate-600">المستحق {b.accrued} ({b.annual_rate} يوماً/سنة · خدمة {b.service_years} سنة) + افتتاحي {b.opening_balance} − المستخدم {b.used}{b.pending ? ` · قيد الطلب ${b.pending}` : ""}</span>
      </div>
      {!b.first_mubashara && <p className="text-xs text-amber-700">أضف تاريخ مباشرة العمل ليُحسب الرصيد.</p>}
      {canEdit && (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs text-slate-500">الرصيد الافتتاحي</span>
          <Input type="number" step="0.5" value={op} onChange={(e) => setOp(e.target.value)} className="h-8 w-24" data-testid="leave-opening-input" />
          <Button size="sm" variant="outline" className="h-8" onClick={() => run(() => api.setLeaveOpening(employeeId, Number(op) || 0), "تم حفظ الرصيد الافتتاحي")} data-testid="leave-opening-save">حفظ</Button>
        </div>
      )}
      <div>
        <p className="mb-1 text-xs font-bold text-slate-600">المباشرات</p>
        {(b.mubasharat || []).length === 0 && <p className="text-xs text-slate-400">لا توجد مباشرات مسجلة{b.first_mubashara ? ` — يُحسب من تاريخ التعيين ${b.first_mubashara}` : ""}</p>}
        <div className="space-y-1">
          {(b.mubasharat || []).map((m) => (
            <div key={m.id} className="flex items-center gap-2 rounded-lg bg-white px-2 py-1 text-xs" data-testid={`mubashara-${m.id}`}>
              {m.kind === "hire" ? <Briefcase className="h-3.5 w-3.5 text-blue-600" /> : <LogIn className="h-3.5 w-3.5 text-emerald-600" />}
              <b className="font-mono-nums" dir="ltr">{m.date}</b><span>{m.kind === "hire" ? "مباشرة عمل" : "مباشرة بعد إجازة"}</span>
              <span className="flex-1 truncate text-slate-400">{m.note}</span>
              {canEdit && <button onClick={() => run(() => api.delMubashara(employeeId, m.id), "تم الحذف")} className="text-slate-300 hover:text-red-600" data-testid={`mubashara-del-${m.id}`}><Trash2 className="h-3.5 w-3.5" /></button>}
            </div>
          ))}
        </div>
        {canEdit && (
          <div className="mt-2 flex flex-wrap items-center gap-2">
            <select value={f.kind} onChange={(e) => setF({ ...f, kind: e.target.value })} className="h-8 rounded-md border px-2 text-xs" data-testid="mubashara-kind">
              <option value="hire">مباشرة عمل (أول مباشرة)</option><option value="return">مباشرة بعد إجازة</option></select>
            <Input type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} className="h-8 w-40" data-testid="mubashara-date" />
            <Input value={f.note} onChange={(e) => setF({ ...f, note: e.target.value })} placeholder="ملاحظة" className="h-8 w-40" />
            <Button size="sm" className="h-8 gap-1" disabled={!f.date} data-testid="mubashara-add"
              onClick={() => run(() => api.addMubashara(employeeId, f), "تمت إضافة المباشرة").then(() => setF({ ...f, date: "", note: "" }))}><Plus className="h-3.5 w-3.5" /> إضافة</Button>
          </div>
        )}
      </div>
    </div>
  );
};
